/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useHUChipStyles = makeStyles<Theme, { color: string; isOutlined: boolean }>({
  root: {
    backgroundColor: ({ color, isOutlined }) => (isOutlined ? 'transparent' : color),
    borderColor: ({ color, isOutlined }) => (isOutlined ? color : 'transparent'),
  },
  outlined: {},
  label: {
    fontSize: '14px',
    lineHeight: '20px',
    color: ({ color, isOutlined }) => (isOutlined ? color : '#FFF'),
  },
});
